
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'feature-card',
  props: {
    imgSrc: {
      type: String,
      required: false,
    },
    imgAlt: String,
    link: String,
    header: String,
    body: String,
  },
});
